<template>
  <div class="collect-case-list-container">
    <case-list :cases="lists" theme="collect-list" :isShowPagination="paginationConfig"></case-list>
  </div>
</template>

<script>
import CaseList from '@/pages/case/_list.vue';
import { collectCases } from '@/api/user';

export default {
  components: {
    CaseList,
  },
  data() {
    return {
      lists: [],
      pageSize: 15,
      paginationConfig: null,
    };
  },
  computed: {
    page() {
      return this.$route.query.page || 1;
    },
  },
  watch: {
    $route: {
      handler: 'init',
      immediate: true,
    },
  },
  methods: {
    init() {
      // 获取数据
      this.getLists();
    },
    async getLists() {
      this.$store.commit('openLoading');
      const res = await collectCases({
        page: this.page,
        page_size: this.pageSize,
      });
      const { data } = res;
      this.lists = data.list;
      this.paginationConfig = data.total.num > 0 ? data.total : null;
      this.$emit('counts', data.total.num);
      this.$store.commit('closeLoading');
    },
  },
};
</script>

<style>

</style>
